export const SET_OPEN_QUESTIONNAIRE_BULK_EDIT_FILTER = '@BULK_OPS/SET_OPEN_QUESTIONNAIRE_BULK_EDIT_FILTER';
export const SET_OPEN_SCHEDULES_BULK_EDIT_FILTER = '@BULK_OPS/SET_OPEN_SCHEDULES_BULK_EDIT_FILTER';
export const SET_OPEN_SITES_BULK_EDIT_FILTER = '@BULK_OPS/SET_OPEN_SITES_BULK_EDIT_FILTER';
export const SET_OPEN_DEPARTMENTS_BULK_EDIT_FILTER = '@BULK_OPS/SET_OPEN_DEPARTMENTS_BULK_EDIT_FILTER';
export const SET_OPEN_USERS_BULK_EDIT_FILTER = '@BULK_OPS/SET_OPEN_USERS_BULK_EDIT_FILTER';
